export const CODE_WORD_SYMBOLS_VALIDATOR = {
    message: 'Не менее одной цифры и одной русской буквы',
    // regexp минимум 1 буква и минимум 1 цифра и только буквы русского алфавита
    reg: '^[А-Яа-я]+[0-9]+([А-Яа-я]*[0-9]*)+$',
};

export const CODE_WORD_MAX_LENGTH = 35;
